export default {
  routes: [
    {
      name: 'briefingtypes',
      path: '/directory/briefingtypes',
      component: () => import('./views/TheBriefingTypes.vue'),

    },

    {
      name: 'briefingtype',
      path: '/directory/briefingtypes/:uuid',
      component: () => import('./views/TheBriefingType.vue'),
    },
  ]
}
